module.exports = __webpack_public_path__ + "static/media/key-insights-zero-state.dc1682a2.svg";